import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-yes-no-dialog',
  templateUrl: './yes-no-dialog.component.html',
})
export class YesNoDialogComponent {
  public message: string;

  constructor(cfg: DynamicDialogConfig, private dialogRef: DynamicDialogRef) {
    this.message = cfg.data.message;
  }

  public returnYes(): void {
    this.dialogRef.close(1);
  }

  public returnNo(): void {
    this.dialogRef.close();
  }
}
